import React from 'react';
import { Card, Col, FormGroup, Row } from 'react-bootstrap';
import { set, isEmpty } from 'lodash';
import { ElementTemplate } from '../TemplateComponent';
import { commonPath } from '../fieldPath';
import { usePurchaseOrderState } from '../PurchaseOrderContext';

export function RenderSupplierFactoryDetails({ data, pIndex, isProductArchived }) {
  const { setPurchaseOrderState, purchaseOrderState, supplierAddress, disableConditions, fromPreview, isPublicPoPage, poAddEditAccess } =
    usePurchaseOrderState();
  const handleChange = (value, keyName) => {
    const copyState = purchaseOrderState;
    let locate = '';
    if (keyName.includes('options')) {
      locate = keyName.split('.options');
    } else {
      locate = keyName.split('.value');
    }
    set(purchaseOrderState, `${locate[0]}.hasError.status`, false);
    set(purchaseOrderState, keyName, value);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const handleDropDown = async (value, fieldName) => {
    switch (fieldName) {
      case 'factoryName':
        await bindFactoryDetails(value);
        break;
      case 'factContactPersonsDetails':
      case 'contactPersonsDetails':
        bindDropDownFields(value, fieldName);
        break;
      default:
        break;
    }
  };

  function bindDropDownFields(values, fieldName) {
    const copyState = purchaseOrderState;
    copyState.templateJsonSchema[pIndex].columns = copyState?.templateJsonSchema[pIndex]?.columns.map((column, colIndex) => {
      column = column.map((col) => {
        if (col?.field === fieldName) {
          col.value = values;
          col.hasError = false;
        }
        if (['contactPersonsDetails', 'factContactPersonsDetails'].includes(fieldName) && ['supplierContactEmail', 'factoryContactEmail'].includes(col.field)) {
          if (col.field === 'supplierContactEmail' && fieldName === 'contactPersonsDetails') {
            col.value = values ? values.email : col.value;
            col.hasError = false;
          }
          if (col.field === 'factoryContactEmail' && fieldName === 'factContactPersonsDetails') {
            col.value = values ? values.email : col.value;
            col.hasError = false;
          }
        }
        return col;
      });
      return column;
    });
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  }

  const bindFactoryDetails = async (values) => {
    const copyState = purchaseOrderState;
    copyState.templateJsonSchema[pIndex].columns = copyState?.templateJsonSchema[pIndex]?.columns.map((column) => {
      column = column.map((col) => {
        switch (col.field) {
          case 'factoryName':
            if (col.hasError) col.hasError.status = false;
            col.value = values;
            break;
          case 'factoryAddress':
            if (col.hasError) col.hasError.status = false;
            col.value = supplierAddress(values).join('\n');
            break;
          case 'factoryCode':
            if (col.hasError) col.hasError.status = false;
            col.value = values.factoryCode || '';
            break;
          case 'factContactPersonsDetails':
            col.options = values.contactPersons || [];
            const ids = col.options.map((val) => val._id);
            if (col.hasError && col.value && col.hasError) col.hasError.status = false;
            col.value = col.value && ids.includes(col.value._id) ? col.value : '';
            break;
          case 'factoryContactEmail':
            if (col.hasError && col.value && col.hasError) {
              col.hasError.status = false;
            }
            col.value = '';
            break;
          default:
            break;
        }
        return col;
      });
      return column;
    });
    copyState.templateJsonSchema.map((ele) => {
      if (ele?.key === 'Shipping_Details') {
        ele?.columns?.map((columnEle) => {
          columnEle.map((colEle) => {
            if (colEle?.label === 'Port of Lading') {
              colEle.value = values?.portOfLanding;
              colEle.hasError = false;
            }
            return colEle;
          });
          return columnEle;
        });
      }
      return ele;
    });
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2 bgcolor-dark">
        <strong>{data?.label}</strong>
      </Card.Header>
      <Card.Body className="py-4">
        <Row className="span_font_size">
          {data?.columns.map((column, index) => {
            const arr = column.filter((col) => col?.enable === true);
            return (
              !isEmpty(arr) && (
                <Col lg={6}>
                  {column.map((col, i) => {
                    return (
                      col?.enable && (
                        <FormGroup key={i}>
                          <ElementTemplate
                            {...col}
                            keys={col?.key}
                            error={col?.hasError}
                            requiredField={col?.required}
                            disable
                            options={col?.options}
                            placeHolder={col?.label}
                            value={col?.value}
                            onChange={(value, path) => {
                              if (['factoryName', 'factContactPersonsDetails', 'contactPersonsDetails'].includes(col?.field)) {
                                handleDropDown(value, col?.field);
                              } else {
                                handleChange(value, path);
                              }
                            }}
                            path={
                              col?.key === 'Check_Boxes' ? commonPath(pIndex, index, i).COMPANY_DETAILS_CHECKBOX : commonPath(pIndex, index, i).COMPANY_DETAILS
                            }
                          />
                        </FormGroup>
                      )
                    );
                  })}
                </Col>
              )
            );
          })}
        </Row>
      </Card.Body>
    </Card>
  );
}

export default RenderSupplierFactoryDetails;
